import { Box } from '@mui/material';
import React from 'react';
import { Drawer } from 'src/components/drawer';
import {
  ALLOWED_FILE_EXTENSIONS_PRODUCT,
  ASSET_UPLOAD_SUPPORTED_FILE_TYPES_PRODUCT,
  SUPPORTED_EXTENSIONS,
  SUPPORTED_FILE_TYPES,
} from 'src/constants';
import { useGetAllAssets } from 'src/hooks/api';

import { useResourceSelector } from '../ResourceSelector.hook';
import { ResourceSelectorContentBody } from './ResourceSelectorContentBody';
import {
  ResourceSelectorSidebarProps,
  ResourceType,
} from './ResourceSelectorSidebar.interface';
import { ResourceSelectorContainer } from './ResourceSelectorSidebar.styled';
import { ResourceSelectorSidebarHeader } from './resourceSelectorSidebarHeader';

export const ResourceSelectorSidebar = React.forwardRef(
  (props: ResourceSelectorSidebarProps, ref) => {
    const {
      data: assets = [],
      isLoading: isLoadingAssets,
      refetch: refetchAssets,
    } = useGetAllAssets();
    const { searchVal, selectedAssets, onChangeSearchVal, onSelectedAssets } =
      useResourceSelector();

    const defaultAsset = assets.find(
      (item) => item.assetName === props.defaultAssetName,
    );

    return (
      <Box ref={ref}>
        <Drawer open={props.openResourceSelectorDrawer}>
          {props.openResourceSelectorDrawer && (
            <ResourceSelectorContainer>
              <ResourceSelectorSidebarHeader
                label={props.label}
                onBackClick={props.onToggleResourceSelectorDrawer}
                showUploadButton={true}
                error={props.error}
                refetchAssets={refetchAssets}
                type={props.type}
                allowedExtensions={
                  props.type === ResourceType.PRODUCT
                    ? ALLOWED_FILE_EXTENSIONS_PRODUCT
                    : SUPPORTED_EXTENSIONS
                }
                supportedFileType={
                  props.type === ResourceType.PRODUCT
                    ? ASSET_UPLOAD_SUPPORTED_FILE_TYPES_PRODUCT
                    : SUPPORTED_FILE_TYPES
                }
              />

              <ResourceSelectorContentBody
                assets={assets}
                searchVal={searchVal}
                isLoadingAssets={isLoadingAssets}
                onChangeSearchVal={onChangeSearchVal}
                selectedAssets={selectedAssets}
                onSelectedAssets={onSelectedAssets}
                onChange={props.onChange}
                type={props.type}
                defaultAsset={defaultAsset}
              />
            </ResourceSelectorContainer>
          )}
        </Drawer>
      </Box>
    );
  },
);
